import { openAlertModal } from 'admin/actions/alert-modal';
import { deleteCustomer } from 'admin/actions/customers';
import React from 'react';
import styled from 'styled-components';
import { useAppDispatch } from '../../../../hooks/useApp';
import { Button } from '../../../atoms/Buttons';
import FA from '../../../atoms/FontAwesome';

const WithdrawalButton = styled(Button)`
  background: #d75f48;
  &:hover {
    background: #c25641;
  }
`;

const ModalWarningMessage = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;

  p {
    margin-bottom: 0;
    color: #d75f48;
  }
`;

const Icon = styled(FA)`
  font-size: 16px;
`;

const WithdrawalCustomer = ({
  customerId,
  onDeleted,
  setApiMessages,
}: {
  customerId: string;
  onDeleted: () => void;
  setApiMessages: (messages: Array<{ text: string; isError: boolean }>) => void;
}) => {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(
      openAlertModal({
        body: (
          <div>
            <p>退会処理を実行してもよろしいですか？</p>
            <ModalWarningMessage>
              <Icon icon="exclamation-triangle" color="#D75F48" />
              <p>この操作は元に戻せません</p>
            </ModalWarningMessage>
          </div>
        ),
        confirmText: '実行',
        confirmColor: 'danger',
        onConfirm: () => {
          deleteCustomer(customerId)
            .then(() => {
              onDeleted();
            })
            .catch((err) =>
              Promise.resolve(err).then((res) =>
                setApiMessages([{ text: `退会に失敗しました (${res.message})`, isError: true }])
              )
            );
        },
      })
    );
  };

  return <WithdrawalButton onClick={handleClick}>ユーザ退会</WithdrawalButton>;
};

export default WithdrawalCustomer;
